// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"708842cc","455":"b11ad9ed","977":"1571d280"}[chunkId] + ".chunk.js";
};